import { Col, FormFeedback } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import Flatpickr from "react-flatpickr";
import SelectField from "../Utils/SelectField";
import { NULL } from "sass";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import React, { useState } from "react";
import { getTimezones } from "../Utils/UtilityFunctions";

const ocppOptions = [
  { label: "OCPP 1.6", value: "ocpp1.6" },
  { label: "OCPP 2.0.1", value: "ocpp2.0.1" },
];

const adminActionOptions = [
  { label: "Activate", value: "Active" },
  { label: "Deactivate", value: "Inactive" },
];

const timezoneOptions = getTimezones();

export default function FormLine4({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
  isCreate,
}) {
  const [openStartTime, setOpenStartTime] = useState(false);
  const [openEndTime, setOpenEndTime] = useState(false);

  const handleOcppChange = (selectedOption) => {
    handleChange({
      target: {
        name: "OCPPVersion",
        value: selectedOption?.value || "",
      },
    });
  };

  const handleTimeZoneChange = (selectedOption) => {
    handleChange({
      target: {
        name: "timeZone",
        value: selectedOption?.value || "",
      },
    });
  };

  const handleTimeChange = (selectedOption, name) => {
    handleChange({
      target: {
        name: name,
        value: selectedOption || "",
      },
    });
  };

  const handleAdminActionChange = (selectedOption) => {
    handleChange({
      target: {
        name: "adminStatus",
        value: selectedOption?.value || "",
      },
    });
  };

  return (
    <>
      {!isCreate ? (
        <>
          {/* <Col xxl={3} md={6}> */}
            {/* <LabelText
              htmlFor="availabilityStartTime"
              className="text-danger"
              displayText="Availability Start Time"
            /> */}
            {/* <LabelText
              htmlFor={"availabilityStartTime"}
              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
              displayText={"Select Availability Start Time"}
            /> */}
            {/* <Flatpickr
              name="availability start time"
              autoComplete="off"
              className="form-control"
              id="availability start time"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
              }}
            /> */}
            {/* <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                name="availabilityStartTime"
                open={openStartTime}
                onOpen={() => setOpenStartTime(true)}
                onClose={() => setOpenStartTime(false)}
                value={values?.availabilityStartTime}
                onChange={(newValue) =>
                  handleTimeChange(newValue, "availabilityStartTime")
                }
                ampm={true}
                format="hh:mm A"
                className="form-control"
                minutesStep={5}
                slotProps={{
                  textField: {
                    placeholder: "",
                    fullWidth: true,
                    onClick: () => setOpenStartTime(true),
                    sx: {
                      "& .MuiInputBase-root": {
                        height: "39px",
                        borderRadius: "8px",
                        fontSize: "14px",
                      },

                      "& input": {
                        padding: "12px 14px",
                        cursor: "pointer",
                        fontSize: "14px",
                      },

                      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#ced4da", 
                        },

                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#ced4da",
                          borderWidth: "1px",
                        },

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ced4da",
                      },

                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ced4da",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider> */}
          {/* </Col> */}
          {/* <Col xxl={3} md={6}>
            <LabelText
              htmlFor="availabilityEndTime"
              className="text-danger"
              displayText="Availability End Time"
            /> */}
            {/* <LabelText
              htmlFor={"availabilityEndTime"}
              classLabelName={`d-block ms-0 rv-sub-label ${"rv-label-muted"} `}
              displayText={"Select Availability End Time"}
            /> */}
            {/* <Flatpickr
              name="availability end time"
              autoComplete="off"
              className="form-control"
              id="availability end time"
              options={{
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
              }}
            /> */}
            {/* <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                name="availabilityEndTime"
                open={openEndTime}
                onOpen={() => setOpenEndTime(true)}
                onClose={() => setOpenEndTime(false)}
                value={values?.availabilityEndTime}
                onChange={(newValue) =>
                  handleTimeChange(newValue, "availabilityEndTime")
                }
                ampm={true}
                format="hh:mm A"
                className="form-control"
                minutesStep={5}
                slotProps={{
                  textField: {
                    placeholder: "",
                    fullWidth: true,
                    onClick: () => setOpenEndTime(true),
                    sx: {
                      "& .MuiInputBase-root": {
                        height: "39px",
                        borderRadius: "8px",
                        fontSize: "14px",
                      },

                      "& input": {
                        padding: "12px 14px",
                        cursor: "pointer",
                        fontSize: "14px",
                      },

                      "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#ced4da", 
                        },

                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#ced4da",
                          borderWidth: "1px",
                        },

                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ced4da",
                      },

                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ced4da",
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider> */}
          {/* </Col> */}

          <Col xxl={3} md={6}>
            <LabelText htmlFor="adminStatus" displayText="Admin Action" />
            <LabelText
              htmlFor={"adminStatus"}
              classLabelName={`d-block ms-0 rv-sub-label ${
                touched.adminStatus && errors.adminStatus
                  ? "rv-label-danger"
                  : "rv-label-muted"
              } `}
              displayText={
                touched.adminStatus && errors.adminStatus
                  ? errors.adminStatus
                  : "Select Admin Action"
              }
            />
            <SelectField
              className="basic-single"
              value={
                values.adminStatus
                  ? adminActionOptions.find(
                      (opt) => opt.value === values.adminStatus
                    )
                  : ""
              }
              handleChange={handleAdminActionChange}
              placeholder={" "}
              handleBlur={handleBlur}
              options={adminActionOptions}
              isClearable={false}
              isMulti={false}
              isLoading={false}
              disabled={isCreate}
              labelName="adminStatus"
              closeMenuOnSelect={true}
            />
          </Col>
        </>
      ) : null}
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor="vendorName"
          displayText="Vendor Name"
          important={"*"}
          className={"text-danger"}
        />
        <LabelText
          htmlFor={"vendorName"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.vendorName && errors.vendorName
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.vendorName && errors.vendorName
              ? errors.vendorName
              : "Enter Vendor Name"
          }
        />
        <InputField
          name="vendorName"
          type="text"
          className="form-control"
          id="vendorName"
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.vendorName || ""}
          invalid={touched.vendorName && errors.vendorName ? true : false}
        />
      </Col>

      <Col xxl={3} md={6}>
        <LabelText htmlFor="firmwareVersion" displayText="Firmware version" />
        <LabelText
          htmlFor={"firmwareVersion"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.firmwareVersion && errors.firmwareVersion
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.firmwareVersion && errors.firmwareVersion
              ? errors.firmwareVersion
              : "Enter Firmware Version"
          }
        />
        <InputField
          name="firmwareVersion"
          type="text"
          className="form-control"
          id="firmwareVersion"
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.firmwareVersion || ""}
        />
      </Col>

      <Col xxl={3} md={6}>
        <LabelText htmlFor="timeZone" displayText="Timezone" />
        <LabelText
          htmlFor={"timeZone"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.timeZone && errors.timeZone
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.timeZone && errors.timeZone
              ? errors.timeZone
              : "Select Timezone"
          }
        />
        {/* <InputField
          name="timeZone"
          type="text"
          className="form-control"
          id="timeZone"
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.timeZone || ""}
        /> */}
        <SelectField
          name="timeZone"
          className="basic-single"
          value={
            values.timeZone
              ? timezoneOptions.find((opt) => opt.value === values.timeZone)
              : null
          }
          handleChange={handleTimeZoneChange}
          handleBlur={handleBlur}
          options={timezoneOptions}
          isClearable={true}
          isMulti={false}
          isLoading={false}
          // isDisabled={isCreate ? false : true}
          labelName="timeZone"
          closeMenuOnSelect={true}
          isRVStyle={true}
          placeholder={" "}
        />
      </Col>

      <Col xxl={3} md={6}>
        <LabelText
          htmlFor="model"
          displayText="Model"
          important={"*"}
          className={"text-danger"}
        />
        <LabelText
          htmlFor={"model"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.model && errors.model ? "rv-label-danger" : "rv-label-muted"
          } `}
          displayText={
            touched.model && errors.model ? errors.model : "Enter Model"
          }
        />
        <InputField
          name="model"
          type="text"
          className="form-control"
          id="model"
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.model || ""}
          invalid={touched.model && errors.model ? true : false}
        />
      </Col>

      <Col xxl={3} md={6}>
        <LabelText htmlFor="OCPPVersion" displayText="OCPP Version" />
        <LabelText
          htmlFor={"OCPPVersion"}
          classLabelName={`d-block ms-0 rv-sub-label ${
            touched.OCPPVersion && errors.OCPPVersion
              ? "rv-label-danger"
              : "rv-label-muted"
          } `}
          displayText={
            touched.OCPPVersion && errors.OCPPVersion
              ? errors.OCPPVersion
              : "Select OCPP Version"
          }
        />
        <SelectField
          className="basic-single"
          value={
            values.OCPPVersion
              ? ocppOptions.find((opt) => opt.value === values.OCPPVersion)
              : ocppOptions[0]
          }
          handleChange={handleOcppChange}
          handleBlur={handleBlur}
          options={ocppOptions}
          isClearable={true}
          isMulti={false}
          isLoading={false}
          isDisabled={isCreate ? false : true}
          labelName="OCPPVersion"
          closeMenuOnSelect={true}
        />
      </Col>
    </>
  );
}